import { Pipe, PipeTransform } from '@angular/core';
import packageInfo from '../../../../package.json';

/**
 * Agrega la versión de la aplicación como query string a la URL de un asset
 * estático, para que un deploy nuevo no siga sirviendo el archivo cacheado:
 *
 *   assets/svg/grid.svg  ->  assets/svg/grid.svg?v=1.7.2
 *
 * Solo aplica a los archivos de `src/assets`, que se copian tal cual al build
 * y por eso NO llevan el hash de contenido que Angular sí pone en los bundles
 * (`outputHashing: "all"`, angular.json:77).
 *
 * La versión sale de `package.json`, que el equipo ya sube en cada release:
 * no hay un segundo número que mantener a mano.
 */
@Pipe({
  name: 'assetVersion',
})
export class AssetVersionPipe implements PipeTransform {
  private static readonly VERSION = packageInfo.version;

  transform(url: string | null | undefined): string {
    if (!url) {
      return '';
    }
    // Una URL absoluta apunta a otro origen (S3, CDN del backend): su cache no
    // la controla este deploy y agregarle la versión solo rompería la firma.
    if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) {
      return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}v=${AssetVersionPipe.VERSION}`;
  }
}
